export default "__VITE_ASSET__b882742b__"